import React, { useEffect } from 'react'
// images//
import ServicesSection from '../Home/ServicesSection'
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import WOW from 'wowjs';
import {ServicesData} from '../ServicesData/ServicesData'

export default function Services() {
  const { t, i18n } = useTranslation();
  const cardsData = ServicesData
  
  useEffect(() => {
    new WOW.WOW({
      live: true,
      mobile: false    
    }).init();
  }, []); 


  return <>
    <div className="container-fluid PagesLyout">
     <section>
      <div className="row justify-content-center">
        <div className="col-md-11 text-center pb-5">
          <h1 className='ServicesTitle mb-3 wow fadeInLeft'   data-wow-delay="0.3s" >
            <Trans i18nKey="servicesSection.mainHeading">
              خدمات قانونية شاملة وفق أعلى المعايير
            </Trans>
          </h1>
          <h3 className=' mb-5 wow fadeIn' data-wow-delay="0.7s" style={{fontFamily:"Saudi"}}>
            <Trans i18nKey="servicesSection.subHeading">
              نقدم مجموعة من الخدمات القانونية التي تلبي احتياجات الأفراد والشركات
            </Trans>
          </h3>
        </div>
        <ServicesSection cardsData={cardsData} />
      </div>

    
    </section> 
     <section className=''>
       <div className="Hero3 px-3 px-md-5">
       <div className="row justify-content-between align-items-center w-100">
       <div className="col-md-auto">
         <h2 className='Title wow fadeInRight'  data-wow-delay="0.3s">
           <Trans i18nKey="servicesSection.consultTitle">
             تحتاج إلى استشارة قانونية؟
           </Trans>
         </h2>
         <h3 className=''   style={{fontFamily:'Saudi'}}>
           <Trans i18nKey="servicesSection.consultText">
             تواصل معنا اليوم لنكون شريكك القانوني الموثوق!
           </Trans>
         </h3>
       </div>

       <div className="col-md-auto p-4 wow fadeIn" data-wow-delay="0.7s">
         <Link to="/info/contact">
         <button className='HeroBtn p-3 px-4 wow fadeInLeft'  data-wow-delay="0.6s">
           <Trans i18nKey="Aboutus.consultTitle">
                             احجز استشارتك القانونية الآن
            </Trans>
         </button>
         </Link>
       </div>
     </div>
   </div>
     </section>
    </div>
    
  </>
}
